import { IS_EVIDENCE_NAVIGATION_ENABLED } from '@/features/flags/legacy-flags';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { SignupSource, UserActivityAction } from '@heidi/schema/ml-scribe';
import { useMemo } from 'react';

type UseEvidenceNavEnabledReturnType = {
  /** Whether to hide the Evidence navigation items for the user. */
  shouldHideNavItemsForEvidenceSignup: boolean;
  /** Whether to show Evidence first in the sidebar. */
  showEvidenceFocusedNav: boolean;
};

export function useEvidenceNavEnabled(): UseEvidenceNavEnabledReturnType {
  const { data: userData } = useQueryUser((data) => ({
    signupSource: data?.signup_source,
    userActivity: data?.user_activity,
  }));

  const hasGeneratedNotes = useMemo(() => {
    const count = userData?.userActivity?.[UserActivityAction.consult_note_generated];
    return (count ?? 0) > 0;
  }, [userData?.userActivity]);

  const shouldHideNavItemsForEvidenceSignup = useMemo(
    () =>
      Boolean(
        userData?.signupSource === SignupSource.evidence &&
        IS_EVIDENCE_NAVIGATION_ENABLED() &&
        !hasGeneratedNotes
      ),
    [userData?.signupSource, hasGeneratedNotes]
  );

  const showEvidenceFocusedNav = useMemo(
    () =>
      Boolean(
        userData?.signupSource === SignupSource.evidence &&
        IS_EVIDENCE_NAVIGATION_ENABLED()
      ),
    [userData?.signupSource]
  );

  return {
    shouldHideNavItemsForEvidenceSignup,
    showEvidenceFocusedNav,
  };
}
